// @ts-nocheck
export const stripExceptNumbersHyphensPeriods = (text) => {
  // Regular expression to match characters other than numbers, hyphens, or periods
  const regex = /[^0-9\-.]/g;

  // Replace all occurrences of non-matching characters with an empty string
  return text.replace(regex, '');
};
export const sanitizeTextToNumberField = (evt) => {
  if (
    (evt.which !== 8 && evt.which !== 0 && evt.which < 48) ||
    evt.which > 57
  ) {
    evt.preventDefault();
  }
};

export const sanitizeNumberAcceptingDot = (evt) => {
  // For reference check ascii table
  // . 0 1 2 3 4 5 6 7 8 9
  const asciiValue = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

  if (evt.target?.value?.split('')?.includes('.') && evt.which === 46) {
    evt.preventDefault();
  }
  if (!asciiValue.includes(evt.which)) {
    evt.preventDefault();
  }
};
export const sanitizeNumberAcceptingDotAndMinus = (evt) => {
  // For reference check ascii table
  // - . 0 1 2 3 4 5 6 7 8 9
  const asciiValue = [45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  const splittedValue = evt.target?.value?.split('');
  if (splittedValue?.includes('.') && evt.which === 46) {
    evt.preventDefault();
  }
  if (evt.which === 45 && evt.target.selectionStart !== 0) {
    evt.preventDefault();
  }
  if (evt.which === 45 && evt.target.value.includes('-')) {
    evt.preventDefault();
  }
  if (
    evt.target.value?.split('.')[1]?.length > 12 ||
    !asciiValue.includes(evt.which)
  ) {
    evt.preventDefault();
  }
  if (!asciiValue.includes(evt.which)) {
    evt.preventDefault();
  }
};
export const sanitizeNumberAcceptingDotWithoutMinus = (evt) => {
  // For reference check ascii table
  // - . 0 1 2 3 4 5 6 7 8 9
  const asciiValue = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  const splittedValue = evt.target?.value?.split('');
  if (splittedValue?.includes('.') && evt.which === 46) {
    evt.preventDefault();
  }
  if (evt.which === 45 && evt.target.selectionStart !== 0) {
    evt.preventDefault();
  }
  if (
    evt.target.value?.split('.')[1]?.length === 12 ||
    !asciiValue.includes(evt.which)
  ) {
    evt.preventDefault();
  }
  if (!asciiValue.includes(evt.which)) {
    evt.preventDefault();
  }
};

export const sanitizeNumberAcceptingOnlyNumbers = (evt) => {
  // For reference check ascii table
  // 0 1 2 3 4 5 6 7 8 9
  const asciiValue = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  const splittedValue = evt.target?.value?.split('');
  if (splittedValue?.includes('.') && evt.which === 46) {
    evt.preventDefault();
  }
  if (evt.which === 45 && evt.target.selectionStart !== 0) {
    evt.preventDefault();
  }
  if (!asciiValue.includes(evt.which)) {
    evt.preventDefault();
  }
};

export const sanitizeTextNotAcceptingDot = (evt) => {
  // For reference check ascii table
  // - . 0 1 2 3 4 5 6 7 8 9
  const asciiValue = [45, 46];
  if (asciiValue.includes(evt.which)) {
    evt.preventDefault();
  }
};

export const twoDigitsAfterDecimal = (e) => {
  const asciiValue = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  if (
    e.target.value?.split('.')[1]?.length === 2 ||
    !asciiValue.includes(e.which)
  ) {
    e.preventDefault();
  }
};

export const fourDigitsAfterDecimal = (e) => {
  const asciiValue = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  if (
    e.target.value?.split('.')[1]?.length === 4 ||
    !asciiValue.includes(e.which)
  ) {
    e.preventDefault();
  }
};

export const twelveDigitsAfterDecimal = (e) => {
  const asciiValue = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  if (
    e.target.value?.split('.')[1]?.length === 12 ||
    !asciiValue.includes(e.which)
  ) {
    e.preventDefault();
  }
};

export const rateValidation = (e) => {
  sanitizeNumberAcceptingDotAndMinus(e);
  twelveDigitsAfterDecimal(e);
};

/* the below regex will not allow the users to enter
(minus),
(two numbers after decimal point),
(two decimal point) ,
Usage Example in - [
  AssignAllowanceModal.js -> onChangeHandler Function
] */
export const regexToValidateAmountAndRateField = /^[0-9][0-9]*[.]?[0-9]{0,2}$/;
export const fourDigitRegAcceptingMinus = /^[-]?[0-9]*(?:\.[0-9]{0,4})?$/;

export const fourDigitReg = /^[0-9]*(?:\.[0-9]{0,4})?$/;

export const twelveDigitReg = /^[0-9]*(?:\.[0-9]{0,12})?$/;

export const twelveDigitRegAcceptingMinus = /^[-]?[0-9]*(?:\.[0-9]{0,12})?$/;

/**
 * Generates a regex pattern to validate numeric input with specified decimal places
 * @param decimalPlaces - Number of decimal places allowed (2-12)
 * @param allowMinus - Whether to allow negative numbers (default: false)
 * @returns RegExp for validating numeric strings
 */

export const getDigitRegex = (
  decimalPlaces: number,
  allowMinus = false,
): RegExp => {
  if (decimalPlaces < 2 || decimalPlaces > 12) {
    throw new Error('Decimal places must be between 2 and 12');
  }
  const minusPrefix = allowMinus ? '[-]?' : '';
  return new RegExp(`^${minusPrefix}[0-9]*(?:\\.[0-9]{0,${decimalPlaces}})?$`);
};
